import { createComponent } from '@carvana/merch-components';

export const Section = createComponent('section', {
  className: 'mt-4xl w-full md:mt-8xl'
});

export const Title = createComponent('h2', {
  className: 'text-text-strong t-heading-2xl sm:t-heading-3xl'
});

export const BlueBox = createComponent('div', {
  className:
    'mt-4xl w-full rounded-xl bg-background-informational-subtle px-2xl py-4xl sm:px-4xl md:px-6xl md:py-6xl'
});

export const InnerWrapper = createComponent('div', {
  className: 'grid grid-rows-2 gap-4xl sm:grid-cols-2 sm:grid-rows-1 sm:gap-2xl'
});

export const SubTitle = createComponent('h3', {
  className: 'text-text-strong t-heading-md'
});

export const ListWrapper = createComponent('div', {
  className: 'flex flex-col gap-xl sm:pr-2xl'
});

export const List = createComponent('ul', {
  className:
    'flex list-disc flex-col gap-md pl-xl text-text-default t-body-md marker:text-text-default'
});

export const Bold = createComponent('span', {
  className: 't-strong-md'
});
